exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-hidden[data-v-29f1f5dc] {\n  display: none;\n}\n.disable[data-v-29f1f5dc] {\n  color: white !important;\n  background-color: #CCCCCC !important;\n  cursor: inherit;\n}\n.trial-limit[data-v-29f1f5dc] {\n  text-align: center;\n  font-size: 14px;\n}\n.trialBox[data-v-29f1f5dc] {\n  height: 60px;\n}\n.personalBox[data-v-29f1f5dc] {\n  border: 1px solid #0042bd;\n}\n.corpolateBox[data-v-29f1f5dc] {\n  border: 1px solid #30876e;\n}\n.corpolateTitle[data-v-29f1f5dc] {\n  color: #30876e;\n}", ""]);

// exports
